// PHOTO PRELOADER
(function() {
	// FUNCTION FOR MANIPULATION IMAGES
	var ImgManipulator = (function() {
		var __private = {
			list: null,
			itemClass: "imglist__item",
			bgLayerClass: "imglist__bg",
			mainItemClass: "imglist__item_main",
			delItemClass: "del",
			newItemMark: "new",
			noneClass: "display_none",
			preloadeClass: "preload",
			delCheckboxClass: "imglist__delcheck",
			rotateCheckClass: "imglist__rotate",
			containerForHiddenID: `hiddenFieldsForPhotos-${Date.now()}`,

			fileArrayName: "photos",
			modifier: "new",
			counter: 1,
			simple: false,

			hiddenName: {
				order : "photo_order",
				del   : "photo_del",
				rotate: "photo_rotate"
			},
			dataset: {
				image_id : "id",		// number for old photos, `new-INDEX-Date.now()` - for new
				order    : "order",		// number
				del      : "del",		// 0 || 1
				inp_name : "inputName", // the name of the input from which the files are downloaded
				counter  : "counter",   // number, counter for new multi inputs
				modifier : "modifier",  // modifier for new files
				rotate   : "rotate",    // deg (0 || 90 || 180 || 270)
			},
			rotateClasses: {
				0  : "deg0",
				90 : "deg90",
				180: "deg180",
				270: "deg270"
			},

			set(list, options) {
				if(list && list instanceof HTMLElement) this.list = list;
				else throw new Error("ImageList not found");

				if(options) { 
					if(options.hiddenName && typeof options.hiddenName === "object") this.hiddenName = options.hiddenName;
					if(options.simple && typeof options.simple === "boolean")        this.simple = options.simple;
				}
			},

			delListener() {
				if(this.list instanceof HTMLElement) {
					this.list.addEventListener("click", function(event) {
						event = event || window.event;
						var target = event.target;
						var item;

						if(target instanceof HTMLElement && target.classList.contains(__private.delCheckboxClass)) {
							item = __private.searchItem(target, __private.itemClass);

							if(item) {
								__private.deleteImage(item);
								__private.deleteSinglePrev(item);
								
								if(item.classList.contains(__private.mainItemClass)) __private.setMainItem();

								setTimeout(() => {
									__private.setHiddenData();
								}, 100);
							}
						}
					});
				}
			},

			rotateListener() {
				if(this.list instanceof HTMLElement) {
					this.list.addEventListener("click", function(event) {
						event = event || window.event;
						var target = event.target;
						var item;

						if(target instanceof HTMLElement && target.classList.contains(__private.rotateCheckClass)) {
							item = __private.searchItem(target, __private.itemClass);

							new Promise((resolve, reject) => {
								if(item instanceof HTMLElement) {
									resolve(() => {
										if(!item.dataset[__private.dataset.rotate])
											item.dataset[__private.dataset.rotate] = 0;
									});
								}
							})
							.then(() => { __private.preloader.start(item); })
							.then(() => { __private.rotateImage(item); })
							.then(() => { __private.setHiddenData(); })
							.then(() => {
								setTimeout(() => {
									__private.preloader.end(item);
								}, 300);
							});

							/*if(item instanceof HTMLElement) {
								if(!item.dataset[__private.dataset.rotate])
									item.dataset[__private.dataset.rotate] = 0;

								__private.preloader.start(item);
								
								__private.rotateImage(item);

								setTimeout(() => {
									__private.setHiddenData();
								}, 100);
							}*/
						}
					});
				}
			},

			setMainItem() {
				var items;
				var mainItdex = 0;

				if(this.list instanceof HTMLElement) {
					items = this.list.querySelectorAll(`.${this.itemClass}`);

					mainItdex = getIndex(0);

					for (let i = 0; i < items.length; i++) {
						const element = items[i];
						
						if(i === mainItdex) element.classList.add(this.mainItemClass);
						else element.classList.remove(this.mainItemClass);
					}
				}

				function getIndex(I) {
					if(items[I] instanceof HTMLElement && items[I].classList.contains(__private.delItemClass))
						return getIndex(I + 1);
					else return I;
				}
			},

			setItemsOrder() {
				var items;

				if(this.list instanceof HTMLElement) {
					items = this.list.children;

					for (let i = 0; i < items.length; i++) {
						const element = items[i];
						
						if(element instanceof HTMLElement && element.classList.contains(this.itemClass))
							element.dataset[this.dataset.order] = i;
					}
				}
			},

			deleteImage(item) {
				if(item instanceof HTMLElement) {
					item.classList.add(__private.delItemClass);

					item.classList.add(__private.noneClass);
					item.dataset[__private.dataset.del] = 1;
				}
			},

			deleteSinglePrev(item) {
				var bgClass = "bg";
				var inpName;
				var input = null;
				var label = null;

				if(item instanceof HTMLElement) {
					inpName = item.dataset[__private.dataset.inp_name];
					if(inpName) input = document.querySelector(`input[type='file'][name='${inpName}']`);
					if(input !== null) label = input.parentElement;
					if(label instanceof HTMLLabelElement && label.classList.contains(bgClass)) {
						label.style.backgroundImage = "";
						label.classList.remove(bgClass);
					}
				}
			},

			rotateImage(item) {
				if(item instanceof HTMLElement) {
					let deg = +item.dataset[__private.dataset.rotate] || 0;
					let step = 90;

					// remove old rotated class
					item.classList.remove(__private.rotateClasses[deg]);

					// calculate new deg
					deg += step;
					if(deg >= 360) deg = 0;

					// set new dataset value
					item.dataset[__private.dataset.rotate] = deg;
					
					// add new class
					item.classList.add(__private.rotateClasses[deg]);
					__private.rotatedImgResize(item);
				}
			},

			createNewInput(thisInput) {
				var parent   = null;
				var newInput = document.createElement("input");

				if(thisInput instanceof HTMLInputElement) {
					parent = thisInput.parentElement;

					newInput.type = thisInput.type;
					__private.setInputName(newInput);
					newInput.classList = thisInput.classList;
					newInput.accept = thisInput.accept;
					newInput.multiple = thisInput.multiple;

					thisInput.style.display = "none";
					//parent.appendChild(newInput);
					parent.insertBefore(newInput, parent.firstElementChild);
				}
			},

			createItems(files, input) {
				var fragment = document.createDocumentFragment();
				var inpName  = false;
				var inpIndex;

				new Promise((resolve, reject) => {
					if(input instanceof HTMLInputElement && input.type === "file")
						inpIndex = input.dataset[__private.dataset.counter] || 0;
						inpName  = input.name;
						resolve();
				})
				.then(() => {
					// remove images, that was loaded before
					this.clearItems(input);
				})
				.then(() => {
					// add new images
					for (let i = 0; i < files.length; i++) {
						const f  = files[i];
						const el = document.createElement("div");
						let ID;

						// ID for single input
						if(input.multiple) ID = i;
						else {
							if(input.name.indexOf('][') !== -1 && input.name.indexOf(']') !== -1)
								ID = +input.name.split('][')[1].split(']')[0] || 0;
							else ID = 0;
						}

						el.classList.add(this.itemClass);
						el.classList.add(this.newItemMark);

						// add preloader
						__private.preloader.start(el);

						// set data attributes
						el.dataset[this.dataset.image_id] = ID;
						el.dataset[this.dataset.del]      = 0;
						el.dataset[this.dataset.counter]  = inpIndex;
						el.dataset[this.dataset.modifier] = this.modifier;
						
						if(inpName) el.dataset[this.dataset.inp_name] = inpName;

						// create div with background image
						this.createBg(el);

						// create delete button for this item
						this.createDelButton(el);

						// create rotation button
						this.createRotateButton(el);

						// add item to fragment
						fragment.appendChild(el);

						// set background
						this.reader(el, f);
					}

					// add new elements in list
					this.list.appendChild(fragment);
				})
				.then(() => {
					// order
					this.setItemsOrder(); //__private.setHiddenData();
				})
				.then(() => {
					// order
					this.setHiddenData();
				})
				.then(() => {
					// remove preloader
					setTimeout(() => {
						for (let i = 0; i < this.list.children.length; i++) {
							const element = this.list.children[i];
	
							__private.preloader.end(element);
						}
					}, 400);
				});



				/*if(input instanceof HTMLInputElement && input.type === "file") {
					inpIndex = input.dataset[__private.dataset.counter] || 0;
					inpName  = input.name;
				}
				
				// remove images, that was loaded before
				this.clearItems(input);

				// add new images
				for (let i = 0; i < files.length; i++) {
					const f  = files[i];
					const el = document.createElement("div");
					let ID;

					// ID for single input
					if(input.multiple) ID = i;
					else {
						if(input.name.indexOf('][') !== -1 && input.name.indexOf(']') !== -1)
							 ID = +input.name.split('][')[1].split(']')[0] || 0;
						else ID = 0;
					}

					el.classList.add(this.itemClass);
					el.classList.add(this.newItemMark);

					__private.preloader.start(el);

					// set data attributes
					el.dataset[this.dataset.image_id] = ID;
					el.dataset[this.dataset.del]      = 0;
					el.dataset[this.dataset.counter]  = inpIndex;
					el.dataset[this.dataset.modifier] = this.modifier;
					
					if(inpName) el.dataset[this.dataset.inp_name] = inpName;

					// create div with background image
					this.createBg(el);

					// create delete button for this item
					this.createDelButton(el);

					// create rotation button
					this.createRotateButton(el);

					// add item to fragment
					fragment.appendChild(el);

					// set background
					this.reader(el, f);
				}

				// add new elements in list
				this.list.appendChild(fragment);

				// order
				this.setItemsOrder();

				setTimeout(() => {
					for (let i = 0; i < this.list.children.length; i++) {
						const element = this.list.children[i];

						__private.preloader.end(element);
					}
				}, 300);
				*/
			},

			createBg(item) {
				var template = `<div class=${this.bgLayerClass}></div>`;

				if(item instanceof HTMLElement) if(item instanceof HTMLElement) item.innerHTML += template;
			},

			createDelButton(item) {
				var template = `
								<label class="imglist__check" title="To delete this image">
									<input class="imglist__delcheck" type="checkbox" value="del">
								</label>
							   `;

				if(item instanceof HTMLElement) item.innerHTML += template;
			},

			createRotateButton(item) {
				var template = `<div class="imglist__rotate" title="To rotate this image"></div>`;

				if(item instanceof HTMLElement) item.innerHTML += template;
			},

			createHiddenContainer() {
				var containerForHidden = document.createElement("div");

				containerForHidden.id = this.containerForHiddenID;
				containerForHidden.classList.add(this.noneClass);

				if(this.list instanceof HTMLElement) {
					let parent = this.list.parentElement;
					let next = false;

					if(this.list.nextElementSibling) next = this.list.nextElementSibling;
					
					if(next instanceof HTMLElement) parent.insertBefore(containerForHidden, next);
					else parent.appendChild(containerForHidden);
				}
			},

			createHiddenFields(item, fragment) {
				var ID;
				var order;
				var del;
				var rotate;
				var hiddenOrder;
				var hiddenDelet;
				var hiddenRotate;
				var index;
				var modifier;
				var container = document.getElementById(this.containerForHiddenID);

				if(item instanceof HTMLElement) {
					ID       = item.dataset[this.dataset.image_id] || false;
					order    = item.dataset[this.dataset.order]    || 0;
					del      = item.dataset[this.dataset.del]      || 0;
					rotate   = item.dataset[this.dataset.rotate]   || 0;
					index    = item.dataset[this.dataset.counter]  || 0;
					modifier = item.dataset[this.dataset.modifier] || false;

					if(ID) {
						let orderName = `${this.hiddenName.order}[${index}][${ID}]`;
						let deletName = `${this.hiddenName.del}[${index}][${ID}]`;
						let rotateName= `${this.hiddenName.rotate}[${index}][${ID}]`;

						if(this.simple) {
							orderName = `${this.hiddenName.order}`;
							deletName = `${this.hiddenName.del}`;
							rotateName= `${this.hiddenName.rotate}`;
						}

						// search or create hidden input for order
						searchOrCreate(hiddenOrder, orderName, order);
						// search or create hidden input for del mark
						searchOrCreate(hiddenDelet, deletName, del);
						// search or create hidden input for rotate
						searchOrCreate(hiddenRotate, rotateName, rotate);
					}
				}

				function createInput(node, name) {
					node = document.createElement("input");

					node.type = "hidden";
					node.name = name;

					return node;
				}

				function searchOrCreate(hidden, name, value) {
					if(container.querySelector(`input[name="${name}"]`))
						hidden = container.querySelector(`input[name="${name}"]`);
					else {
						hidden = createInput(hidden, name);
						fragment.appendChild(hidden);
					}

					hidden.value = value;
				}
			},

			clearItems(input) {
				var items;
				var inpName = false;

				if(input instanceof HTMLInputElement && input.type === "file") inpName = input.name;

				if(this.list instanceof HTMLElement) {
					items = this.list.children;

					for (let i = 0; i < items.length; i++) {
						let element = items[i];
						
						if(element instanceof HTMLElement && element.classList.contains(this.newItemMark) && element.dataset[this.dataset.inp_name] === inpName) {
							this.clearHiddenFields(element);
							this.list.removeChild(element);
							element = null;
							i--;
						}
					}
				}
			},

			clearHiddenFields(elem) {
				var ID = false;
				var hiddenOrder;
				var hiddenDelet;
				var hiddenRotate;
				var container = document.getElementById(this.containerForHiddenID);

				if(elem instanceof HTMLElement) {
					ID = elem.dataset[this.dataset.image_id];

					let orderName = `${this.hiddenName.order}[${ID}]`;
					let deletName = `${this.hiddenName.del}[${ID}]`;
					let rotateName= `${this.hiddenName.rotate}[${ID}]`;

					if(ID && container instanceof HTMLElement) {
						hiddenOrder = container.querySelector(`input[name="${orderName}"]`);
						hiddenDelet = container.querySelector(`input[name="${deletName}"]`);
						hiddenRotate= container.querySelector(`input[name="${rotateName}"]`);

						if(hiddenOrder  instanceof HTMLElement) hiddenOrder.parentElement.removeChild(hiddenOrder);
						if(hiddenDelet  instanceof HTMLElement) hiddenDelet.parentElement.removeChild(hiddenDelet);
						if(hiddenRotate instanceof HTMLElement) hiddenRotate.parentElement.removeChild(hiddenRotate);
					}
				}
			},

			reader(el, file) {
				var reader = new FileReader();
				var bg = el;

				for (let i = 0; i < el.children.length; i++) {
					const element = el.children[i];
					
					if(element instanceof HTMLElement && element.classList.contains(this.bgLayerClass)) {
						bg = element;
						break;
					}
				}

				reader.onloadend = function () {
					bg.style.backgroundImage = `url(${reader.result})`;
				}
				
				if(file) reader.readAsDataURL(file);
				else bg.style.backgroundImage = "";
			},

			rotatedImgResize(item) {
				var deg = +item.dataset[__private.dataset.rotate];
				var w   = item.clientWidth;
				var h   = item.clientHeight;
				var bg  = item.getElementsByClassName(__private.bgLayerClass)[0];

				if(bg instanceof HTMLElement) {
					if(deg === 90 || deg === 270) {
						bg.style.width = `${h}px`;
						bg.style.height= `${w}px`;
					} else {
						bg.style.width = ``;
						bg.style.height= ``;
					}
				}
			},

			searchItem(el, className) {
				if(el !== null && el instanceof HTMLElement && el !== undefined && el !== document.body) {
					if(el.classList.contains(className)) return el;
					else return __private.searchItem(el.parentElement, className);
				} else return false;
			},

			setInputName(input) {
				if(input && input instanceof HTMLInputElement) {
					input.name = `${__private.fileArrayName}[${__private.counter}][]`;
					input.dataset[__private.dataset.counter] = __private.counter;

					__private.counter++;
				}
			},

			setHiddenData() {
				var items;
				var container = document.getElementById(this.containerForHiddenID);
				var fragment  = document.createDocumentFragment();

				if(this.list instanceof HTMLElement) {
					items = this.list.children;

					for (let i = 0; i < items.length; i++) {
						const el = items[i];

						this.createHiddenFields(el, fragment);

						container.appendChild(fragment);
					}
				}
			},

			preloader: {
				start(item) {
					item.classList.add(__private.preloadeClass);
				},

				end(item) {
					item.classList.remove(__private.preloadeClass);
				}
			}
		};

		return {
			init(list, options) {
				__private.set(list, options);
				__private.delListener();
				__private.rotateListener();
				__private.setItemsOrder();
				__private.createHiddenContainer();
				__private.setHiddenData();
			},

			order() {
				__private.setItemsOrder();
				__private.setHiddenData();
			},

			main() {
				__private.setMainItem();
			},

			delete(elem) {
				__private.deleteImage(elem);
				__private.setHiddenData();
			},

			create(files, input) {
				if(files instanceof FileList) {
					__private.createItems(files, input);
					__private.setItemsOrder();
					__private.setHiddenData();
				}
			},

			setHidden() {
				__private.setHiddenData();
			},

			additionalLoading(input) {
				__private.createNewInput(input);
			},

			createInputName(input) {
				__private.setInputName(input);
			}
		};
	})();
	
	
	
	document.addEventListener("DOMContentLoaded", function() {
		var containerSelector = "#sortableImgList";
		var sortable = $(containerSelector);

		if(document.querySelector(containerSelector)) {
			// Init module
			ImgManipulator.init(document.querySelector(containerSelector));

			// RUN JQUERY UI SORTABLE PLUGIN
			// init sortable
			if(!isMobile.Android()) sortable.sortable();

			// POST requiest when stop
			sortable.on("sortstop", function( event, ui ) {
				// set new orders
				ImgManipulator.order();

				// set new main item
				ImgManipulator.main();
			});

			// Main Item
			ImgManipulator.main();

			// CREATE NEW ITEMS
			let label = document.getElementById("editPhotoGallery");
			if(label instanceof HTMLLabelElement) {
				// create name for fitst input
				ImgManipulator.createInputName(label.firstElementChild);
				// event listaner
				label.addEventListener("change", createNewPreviewsEvent);
			}


			// CREATE NEW ITEMS - for single inputs
			let sides = document.getElementById("carSides");
			if(sides instanceof HTMLElement) {
				let singleLabels = sides.getElementsByTagName("label");

				for (let i = 0; i < singleLabels.length; i++) {
					const l = singleLabels[i];
					
					if(l instanceof HTMLLabelElement && l.firstElementChild instanceof HTMLInputElement && l.firstElementChild.type === "file") {
						l.addEventListener("change", createNewPreviewsEvent);
					}

				}
			}

			
			// function for event listener
			function createNewPreviewsEvent(event) {
				event = event || window.event;
	
				var input = this.firstElementChild;
				var fileList;

				if(input instanceof HTMLInputElement && input.type === "file") {
					fileList = input.files;

					ImgManipulator.create(fileList, input);

					setTimeout(() => {
						// set new main item
						ImgManipulator.main();

						// create new input for additional loading
						if(input.multiple) ImgManipulator.additionalLoading(input);
					}, 300);
				}
			}
		}


		// DEALER LICENSE
		var uploadLicense = document.getElementById("licenseUpload");
		var licensePrewiev= document.getElementById("licenseContainer");

		if(uploadLicense && licensePrewiev) {
			let name = "license_photo";

			// Init module
			ImgManipulator.init(licensePrewiev, {
				simple    : true,
				hiddenName: {
					order : `${name}_order`,
					del   : `${name}_del`,
					rotate: `dealer_license_rotation`
				}
			});

			uploadLicense.addEventListener("change", createLicensePreviewEvent);
			document.addEventListener("click", viewOldLicense);

			// function for event listener
			function createLicensePreviewEvent(event) {
				event = event || window.event;
	
				var input = this.firstElementChild;
				// var fileList;

				new Promise((resolve, reject) => {
					if(input instanceof HTMLInputElement && input.type === "file") resolve(input);
				})
					.then(input => {
						var fileList;

						fileList = input.files;
						ImgManipulator.create(fileList, input);
					})
					.then(() => {
						var license = document.getElementById("licenseImage");

						if(license instanceof HTMLElement) license.style.display = "none";
					});

				/*if(input instanceof HTMLInputElement && input.type === "file") {
					fileList = input.files;

					ImgManipulator.create(fileList, input);

					setTimeout(() => {
						// create new input for additional loading
						if(input.multiple) ImgManipulator.additionalLoading(input);
					}, 300);
				}*/
			}

			// function for delete license preview
			function viewOldLicense(event) {
				event = event || window.event;
				var target = event.target;
				var delButtonClass = "imglist__delcheck";
				var license = document.getElementById("licenseImage");

				if(license instanceof HTMLElement && target instanceof HTMLElement && target.classList.contains(delButtonClass))
					license.style.display = "block";
			}
		}
	});
})();